import React, { useEffect, useState } from "react";

import placeholderSrc from "../../assets/images/team_badge_placeholder.svg";

/**
 * TeamBadge - Team crest/logo image with automatic placeholder fallback
 *
 * Props:
 *   src       - image URL (optional)
 *   alt       - alt text (defaults to "Team")
 *   size      - tailwind size class e.g. "w-10 h-10" (defaults to "w-10 h-10")
 *   className - additional classes (e.g. "rounded-full object-cover")
 */
const TeamBadge = ({ src, alt = "Team", size = "w-4 h-4", containerSize = "w-[52px] h-[52px]", className = "" }) => {
  const [imgSrc, setImgSrc] = useState(src || placeholderSrc);
  const [isPlaceholder, setIsPlaceholder] = useState(!src);

  // Re-sync when the src prop changes (e.g. after a team swap). useState only
  // reads its initializer on mount, and this instance is reused across renders
  // (FixtureCard keys by fixture._id, which is stable through a swap), so
  // without this the crest would stay stale until a full page refresh.
  useEffect(() => {
    setImgSrc(src || placeholderSrc);
    setIsPlaceholder(!src);
  }, [src]);

  const handleError = () => {
    setImgSrc(placeholderSrc);
    setIsPlaceholder(true);
  };

  return (
    <div className={`flex items-center justify-center bg-app-surface rounded-full ${containerSize} border border-app-border overflow-hidden`}>
      <img
        src={imgSrc}
        alt={alt}
        className={`${isPlaceholder ? size : "object-cover"} ${className}`}
        onError={handleError}
      />
    </div>
  );
};

export default TeamBadge;
